import * as amplitude from "@amplitude/analytics-browser";
import { Button, Flex } from "@chakra-ui/react";
import { Form, Formik } from "formik";
import { FunctionComponent, useMemo } from "react";
import { CustomQuestionAnswersByQuestionId } from "src/schemas/CustomQuestionType";
import { answerIsEmpty } from "src/services/formTemplate/answer";
import { useCustomQuestionContext } from "../context/CustomQuestionContext";
import { AnswerBankEntryFormFields } from "./AnswerBankEntryFormFields";

type AnswerBankEntryFormProps = {
  initialValues: Record<string, string>;
  onSubmitHandler: (values: CustomQuestionAnswersByQuestionId) => Promise<void>;
};

/**
 * The content and arrangement of this form is based on the CustomQuestionType
 * and its fields. This component transforms the fields' question into
 * shapes consumable by our Avela Form framework.
 */
export const AnswerBankEntryForm: FunctionComponent<
  AnswerBankEntryFormProps
> = (props) => {
  const { initialValues, onSubmitHandler } = props;

  const {
    validate,
    fieldQuestions,
    setShowAnswerBank,
    setAnswerToEdit,
    customQuestion,
  } = useCustomQuestionContext();

  const isEditingAnswer = useMemo(() => {
    return !answerIsEmpty(initialValues);
  }, [initialValues]);

  return (
    <Flex direction="column" gap={2}>
      <Formik<CustomQuestionAnswersByQuestionId>
        initialValues={initialValues}
        onSubmit={onSubmitHandler}
        validate={validate}
      >
        {({ isSubmitting, isValid }) => (
          <Form>
            <AnswerBankEntryFormFields
              fieldQuestions={fieldQuestions}
              isEditingAnswer={isEditingAnswer}
              isSubmitting={isSubmitting}
              isValid={isValid}
            />
            <Button
              size="sm"
              variant="outline"
              colorScheme="gray"
              width="100%"
              mt={2}
              onClick={() => {
                setShowAnswerBank(true);
                setAnswerToEdit(null);
                amplitude.track("Cancel adding entry clicked", {
                  cqt_name: customQuestion.question,
                });
              }}
            >
              Cancel
            </Button>
          </Form>
        )}
      </Formik>
    </Flex>
  );
};
